import { useEffect, useState } from "react";
import {
  viewActivity,
  viewSelConversationActivity,
} from "../services/chatService";

export const useActivityPnl = (skipLoader = false, refreshDependency = 0) => {
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchActivityData = async () => {
      try {
        if (!skipLoader) {
          setLoading(true);
        }
        await delay(500);

        const response = await viewActivity();
        setActivity(response.get_activity_details);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchActivityData();
  }, [skipLoader, refreshDependency]);
  return { loading, activity };
};

export const useConversationActivity = (refreshConv) => {
  const [loadingConv, setLoadingConv] = useState(true);
  const [sendingmessage, setSendingmessage] = useState([]);
  const [recivingMessage, setRecivingmessage] = useState([]);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchConversation = async () => {
      try {
        setLoadingConv(true);
        setSendingmessage([]);
        setRecivingmessage([]);
        await delay(500);

        const response = await viewSelConversationActivity();
        if (
          response.get_single_message &&
          response.get_single_message.length > 0
        ) {
          setSendingmessage(response.get_single_message || []);
        } else {
          setSendingmessage([]);
          setRecivingmessage([]);
        }
      } catch (error) {
        setSendingmessage([]);
        setRecivingmessage([]);
      } finally {
        setLoadingConv(false);
      }
    };
    fetchConversation();
  }, [refreshConv]);

  return { loadingConv, sendingmessage, recivingMessage };
};
